export const ROLES = {
  COMERCIAL: 'Comercial',
  TRADER: 'Trader',
  MIDDLE_OFFICE: 'MiddleOffice',
  ADMIN: 'Admin',
  SUPER_ADMIN: 'SuperAdmin',
  // Productor externo: usuario dado de alta como productor en el Sistema de
  // Gestión Comercial, con su cuenta @axoncapital o una de Google de otro dominio.
  // No elige rol: entra directo a su planilla y solo ve/carga operaciones de sus
  // propios clientes (ver docs/productores.md).
  PRODUCTOR: 'Productor',
};

export const ROLE_LABELS = {
  [ROLES.COMERCIAL]: 'Comercial',
  [ROLES.TRADER]: 'Trader',
  [ROLES.MIDDLE_OFFICE]: 'Middle Office',
  [ROLES.ADMIN]: 'Admin',
  [ROLES.SUPER_ADMIN]: 'Super Admin',
  [ROLES.PRODUCTOR]: 'Productor',
};

// Dueño de la planilla: siempre Admin y el único que nombra o quita administradores.
// Es la misma lista que `isOwner()` en firestore.rules: cambiar las dos juntas.
export const OWNER_EMAILS = ['vviotti@axoncapital.com.ar'];

// Roles que un admin asigna desde el panel Usuarios (rolesUsuarios/{email}).
export const ROLES_ASIGNABLES = [ROLES.ADMIN, ROLES.TRADER, ROLES.MIDDLE_OFFICE, ROLES.COMERCIAL];

// Roles que el dueño puede delegar para que otro los asigne (`asigna` en rolesUsuarios).
export const ROLES_DELEGABLES = [ROLES.TRADER, ROLES.MIDDLE_OFFICE, ROLES.COMERCIAL];

// Transición: quien todavía no tiene rol asignado ni figura como comercial en el SGC
// elige uno de estos al entrar. Comercial ya no se elige: sale del SGC o del panel.
export const ROLES_ELEGIBLES_SIN_ASIGNAR = [ROLES.TRADER, ROLES.MIDDLE_OFFICE];

// Roles con los que un admin puede actuar sin cerrar sesión.
export const ROLES_OPERATIVOS_ADMIN = [ROLES.ADMIN, ROLES.TRADER, ROLES.MIDDLE_OFFICE, ROLES.COMERCIAL];
